/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const BooleanClaimValue: core.serialization.ObjectSchema<
    serializers.BooleanClaimValue.Raw,
    Truvity.BooleanClaimValue
> = core.serialization.object({
    value: core.serialization.boolean(),
});

export declare namespace BooleanClaimValue {
    export interface Raw {
        value: boolean;
    }
}
